import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useApiPost } from '@sierralabs/core-ui';
export function useUnlinkEntity(props) {
    const { routeParam, tableName, relations } = props;
    const params = useParams();
    const id = routeParam ? params[routeParam] : undefined;
    const { data, isLoading, error, response, post } = useApiPost(`entities/${tableName}/${id}/unlink`);
    const unlinkEntities = useCallback((ids) => {
        if (!tableName) {
            console.error('[useUnlinkEntity] missing config');
            return;
        }
        console.log('[useUnlinkEntity]\n  relations: %s\n  ids: %o', [tableName].concat(relations || []).join(' -> '), ids);
        post({ ids, relations: relations || [] });
    }, [relations, tableName, post]);
    return {
        entities: data,
        isUnlinking: isLoading,
        unlinkError: error,
        response,
        unlinkEntities
    };
}
//# sourceMappingURL=useUnlinkEntity.js.map